import { ITranslationItem, ITranslationItems } from '../language';

export const FORM_LABEL: ITranslationItems = {
  required: { en: '(Optional)', nl: '(Optioneel)' },
};

export const CHECKBOX_ERROR: ITranslationItem = {
  nl: 'Je dient dit veld te accepteren om je aanvraag te verzenden',
  en: 'Accepting this field is mandatory to submit your request',
};

export const RADIO_ERROR: ITranslationItem = {
  nl: 'Het selecteren van één optie is verplicht',
  en: 'Select at least one option is mandatory',
};

export const DEFAULT_ERROR: ITranslationItem = {
  nl: 'Het invullen van dit veld is verplicht',
  en: 'Filling in this field is mandatory',
};
